"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSanitisedUrl = getSanitisedUrl;
exports.updateSession = updateSession;
exports.getDefaultCountryPickerOptions = getDefaultCountryPickerOptions;
exports.getCountryFlagImageHTML = getCountryFlagImageHTML;
exports.getBrowserBundle = getBrowserBundle;
exports.bundleToCountryObj = bundleToCountryObj;
exports.setUpCountries = setUpCountries;
exports.sessionToCountryObj = sessionToCountryObj;
exports.createDomElement = createDomElement;
exports.removeChildren = removeChildren;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _browserBundle = require("@flowio/browser-bundle");

var _webSdk = require("@flowio/web-sdk");

var _find = _interopRequireDefault(require("lodash/find"));

var _spritePositions = _interopRequireDefault(require("./sprite-positions.json"));

// @ts-check
// @ts-ignore  JSON module resolution
// const CACHE_REFRESH_MILLIS = 60000;
// const CACHE_TIMESTAMP_KEY = 'timeStamp';
var browserBundleDataEventName = 'browser_bundle_data';
/** @typedef {io.flow.reference.v0.models.Country} ApiCountry */

/** @typedef {io.flow.session.v0.unions.Session} Session */

/** @typedef {io.flow.session.v0.models.SessionPutForm} SessionPutForm */

/** @typedef {import('./types').CountryOption} CountryOption */

/** @typedef {import('./types').CountryPickerOptionData} CountryPickerOptionData */

/** @typedef {import('./types').CountryPickerOptions} CountryPickerOptions */

/** @typedef {import('./types').DropdownOptions} DropdownOptions */

/** @typedef {import('./types').DropdownOptionConfig} DropdownOptionConfig */

/** @typedef {import('./types').FlowWindow} FlowWindow */

/** @typedef {import('./types').CountryFlagImageHTMLOptions} CountryFlagImageHTMLOptions */

/** @typedef {io.flow.internal.v0.models.BrowserBundle} BrowserBundle */

/** @typedef {io.flow.internal.v0.models.CountryPickerData} CountryPickerData */

/**
 * @description strips "flow_*" query parameters from URL
 * @param {string} url
 * @returns {string}
 */

function getSanitisedUrl(url) {
  var searchIndex = url.indexOf('?');

  if (searchIndex === -1) {
    return url;
  }

  var parsedQS = (0, _webSdk.parseQueryString)(url.substr(searchIndex));
  /** @type {import('@flowio/web-sdk').Serializable} */

  var cleanQS = {};
  Object.keys(parsedQS).forEach(function (key) {
    if (!/^flow_/.test(key)) {
      cleanQS[key] = parsedQS[key];
    }
  });
  return "".concat(url.substring(0, searchIndex), "?").concat((0, _webSdk.stringify)(cleanQS));
}

function updateSession(form, sessionId, organization, callBack) {
  var store = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  (0, _webSdk.request)( // @ts-ignore  can be un-ignored after this merge: https://github.com/flowcommerce/web-sdk/pull/16
  {
    url: "https://api.flow.io/sessions/".concat(sessionId, "/organizations/").concat(organization),
    method: 'PUT',
    headers: {
      Authorization: "Session ".concat(sessionId)
    },
    data: form
  }).then(function (
  /** @type {import('@flowio/web-sdk').NetworkResponse} */
  result) {
    if (result.ok && result.status === 201) {
      if (store) {
        localStorage.setItem('_f60_session', JSON.stringify(result.response));
      }

      if (callBack) {
        callBack(result.status, result.response);
      } else {
        window.location.assign(getSanitisedUrl(window.location.href));
      }
    }
  });
}
/** @type {(country: CountryOption, currency?: string) => SessionPutForm} */


function onSelectionWithCurrency(country, currency) {
  return {
    country: country.iso_3166_3,
    currency: currency || country.default_currency
  };
}
/** @type {(country: CountryOption, currency?: string) => SessionPutForm} */


function onSelectionNoCurrency(country, currency) {
  if (currency) {
    return {
      country: country.iso_3166_3,
      currency: currency
    };
  }

  return {
    country: country.iso_3166_3
  };
}

function labelFormatterWithCurrency(country) {
  var currencyStr = country.currency ? " (".concat(country.currency, ")") : '';
  return "".concat(country.name).concat(currencyStr);
}

function labelFormatterNoCurrency(country) {
  return country.name;
}
/**
 * @returns {CountryPickerOptions}
 */


function getDefaultCountryPickerOptions() {
  var displayDefaultCurrency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var onSelectionFunction = displayDefaultCurrency ? onSelectionWithCurrency : onSelectionNoCurrency;
  var labelFormatterFunction = displayDefaultCurrency ? labelFormatterWithCurrency : labelFormatterNoCurrency;
  var extraMessagingString = displayDefaultCurrency ? 'You are currently shipping to {country} and your order will be billed in {currency}.' : 'You are currently shipping to {country}';
  return {
    logo: true,
    containerId: 'country-picker',
    currentExperience: undefined,
    modalTitle: 'Select Shipping Country',
    onSelection: onSelectionFunction,
    labelFormatter: labelFormatterFunction,
    onSessionUpdate: undefined,
    enableExtraMessaging: false,
    isLandingMat: false,
    showLandingOnNoExp: true,
    showDeliveryWindow: true,
    showPaymentIcons: true,
    extraMessagingString: extraMessagingString,
    displayDefaultCurrency: displayDefaultCurrency
  };
}
/**
 * @param iso_3166_2 {string}
 * @param optionLogo {boolean}
 * @param label {string}
 * @param [options] {CountryFlagImageHTMLOptions}
 * @returns {string}
 */
// eslint-disable-next-line camelcase


function getCountryFlagImageHTML(iso_3166_2, optionLogo, label) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var transparentGifSrc = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
  var classAttr = options.className ? " class=\"".concat(options.className, "\"") : '';

  if (!optionLogo) {
    return '';
  }

  if (options.imgSrc) {
    // eslint-disable-next-line
    return "<img alt=\"".concat(label, "\" ").concat(classAttr, " style=\"display: inline-block\" src=\"").concat(options.imgSrc, "\" />");
  } // eslint-disable-next-line


  return "<img alt=\"".concat(label, "\" ").concat(classAttr, " src=\"").concat(transparentGifSrc, "\" style=\"background-image: url(https://cdn.flow.io/util/icons/flags-v2/svg/iso_2_flags.svg); background-position: ").concat(_spritePositions["default"][iso_3166_2], "; width: 21px; height:15px; display: inline-block\" />");
}
/**
 * @param {Session} session
 * @returns {Promise<io.flow.internal.v0.models.BrowserBundle>}
 */


function getBrowserBundle(session) {
  return _browserBundle.browserBundleService.fetch({
    session: session
  });
}
/**
 * @param {io.flow.internal.v0.models.CountryPickerData} countryPickerBundle
 * @returns {CountryPickerOptionData}
 */


function bundleToCountryObj(countryPickerBundle) {
  var bundleCountries = countryPickerBundle.countries;
  var countries = bundleCountries.map(function (country) {
    return {
      name: country.name,
      iso_3166_2: country.iso_3166_2,
      iso_3166_3: country.iso_3166_3,
      currency: country.default_currency
    };
  });
  return {
    countries: countries,
    currencies: countryPickerBundle.currencies,
    country_data: countryPickerBundle.country_data,
    experience_data: countryPickerBundle.experience_data
  };
}
/** @type {FlowWindow} */
// @ts-ignore


var flWindow = window;
/** @type {(options: CountryPickerOptions, session: Session, callBack: Function) => Promise<any>} */

function setUpCountries(options, session, callback) {
  return new Promise(function (resolve, reject) {
    if (options.countries) {
      // Don't want to convert already formatted countries
      resolve({
        countries: options.countries,
        currencies: options.currencies
      });
    } else if (flWindow.Flow && flWindow.Flow.set) {
      flWindow.Flow.set('on', browserBundleDataEventName,
      /** @type {(bundleData: BrowserBundle) => void} */
      function (bundleData) {
        return resolve(bundleToCountryObj(bundleData.country_picker));
      });
    } else if (flWindow.flow && flWindow.flow.cmd) {
      flWindow.flow.cmd('on', browserBundleDataEventName,
      /** @type {(bundleData: BrowserBundle) => void} */
      function (bundleData) {
        return resolve(bundleToCountryObj(bundleData.country_picker));
      });
    } else {
      if (!session) {
        var errMsg = 'You must pass in a country object array if you are not in a flow environment'; // eslint-disable-next-line no-console

        console.error(errMsg);
        reject(new Error(errMsg));
      }

      getBrowserBundle(session).then(function (
      /** @type {BrowserBundle} */
      browserBundle) {
        resolve(bundleToCountryObj(browserBundle.country_picker));
      });
    }
  }).then(function (countryPickerData) {
    callback(countryPickerData);
  });
}
/**
 * @param {Session} session
 * @param {CountryOption[]} [countries]
 * @returns {CountryOption}
 */


function sessionToCountryObj(session, countries) {
  var country = {
    iso_3166_3: session.geo.country.iso_3166_3,
    iso_3166_2: session.geo.country.iso_3166_2,
    currency: session.geo.currency.iso_4217_3,
    name: session.geo.country.name,
    language: session.geo.country.languages[0]
  };

  if (countries) {
    var countryMatch = (0, _find["default"])(countries, function (c) {
      return c.iso_3166_3 === country.iso_3166_3;
    });

    if (countryMatch && countryMatch.label) {
      country.label = countryMatch.label;
    }
  }

  return country;
}
/**
 * @param {string} nodeName
 * @param {{[key:string]: string}} [nodeAttributes]
 * @returns {HTMLElement | SVGElement}
 */


function createDomElement(nodeName) {
  var nodeAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var svgNS = 'http://www.w3.org/2000/svg';
  var el;
  var nodeAttributesCopy = (0, _objectSpread2["default"])({}, nodeAttributes);

  if (nodeAttributes && nodeAttributes.xmlns && nodeAttributes.xmlns === svgNS) {
    el = document.createElementNS(svgNS, nodeName);
    delete nodeAttributesCopy.xmlns;
  } else {
    el = document.createElement(nodeName);
  }

  var attrKeys = Object.keys(nodeAttributesCopy);

  for (var i = 0; i < attrKeys.length; i += 1) {
    el.setAttribute(attrKeys[i], nodeAttributesCopy[attrKeys[i]]);
  }

  return el;
}
/**
 * @param {Element} node
 * @return {Element}
 */


function removeChildren(node) {
  for (var i = 0; i < node.childNodes.length; i += 1) {
    node.removeChild(node.childNodes[i]);
  }

  return node;
}


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/country-picker/lib/utilities.js
// module id = 145
// module chunks = 0 1